import { render, staticRenderFns } from "./baseEdit.vue?vue&type=template&id=d2278d76&scoped=true&"
import script from "./baseEdit.vue?vue&type=script&lang=js&"
export * from "./baseEdit.vue?vue&type=script&lang=js&"
import style0 from "./baseEdit.vue?vue&type=style&index=0&id=d2278d76&lang=less&scoped=true&"
import style1 from "./baseEdit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2278d76",
  null
  
)

export default component.exports